import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Toaster } from "@/components/ui/sonner";
import { ProductsProvider } from "@/context/ProductsContext";
import { AuthProvider, RequireAdmin } from "@/context/AuthContext";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProductForm from "@/pages/admin/AdminProductForm";
import AdminAccount from "@/pages/admin/AdminAccount";
import AdminForgotPassword from "@/pages/admin/AdminForgotPassword";
import AdminResetPassword from "@/pages/admin/AdminResetPassword";

const SiteLayout = () => (
  <>
    <Header />
    <main className="min-h-screen"><Outlet /></main>
    <Footer />
  </>
);

const AdminLayout = () => (
  <AuthProvider>
    <Outlet />
  </AuthProvider>
);

function App() {
  return (
    <BrowserRouter>
      <ProductsProvider>
        <SmoothScroll />
        <Routes>
          <Route path="/admin" element={<AdminLayout />}>
            <Route path="login" element={<AdminLogin />} />
            <Route path="forgot-password" element={<AdminForgotPassword />} />
            <Route path="reset-password" element={<AdminResetPassword />} />
            <Route index element={<RequireAdmin><AdminDashboard /></RequireAdmin>} />
            <Route path="account" element={<RequireAdmin><AdminAccount /></RequireAdmin>} />
            <Route path="products/new" element={<RequireAdmin><AdminProductForm /></RequireAdmin>} />
            <Route path="products/:slug" element={<RequireAdmin><AdminProductForm /></RequireAdmin>} />
          </Route>
          <Route element={<SiteLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:slug" element={<ProductDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<Home />} />
          </Route>
        </Routes>
        <Toaster position="bottom-right" />
      </ProductsProvider>
    </BrowserRouter>
  );
}

export default App;
